import {
	Datepicker as DatePickerLib,
	DatepickerProps as DatepickerLibProps,
} from '@ui-kitten/components';

import { InputErrors } from '../Input';
import { CommonFieldProps } from '../commonFieldProps';

export interface DatepickerProps extends DatepickerLibProps, CommonFieldProps {}

export const Datepicker = ({ status, error, errors, ...props }: DatepickerProps) => {
	const statusColor = error ? 'danger' : (status as 'basic' | 'danger');

	return (
		<DatePickerLib caption={<InputErrors errors={errors} />} status={statusColor} {...props} />
	);
};
